import "@hotwired/turbo-rails";

// Turbo 8 refresh morphing vs Trix: morph diffs attributes in place, which
// strips the attributes Trix adds at initialization (contenteditable,
// trix-id, role) from any <trix-editor> whose node survives the morph — the
// element stays connected, connectedCallback never re-fires, and the editor
// is left dead (seen on the admin ticket page's note modal). Re-cloning the
// bare element re-triggers Trix's initialization. Editors that morph
// replaced wholesale (e.g. the reply form after a submit) re-initialize on
// their own and are skipped — a live editor always carries a trix-id.
addEventListener("turbo:morph", () => {
  document.querySelectorAll("trix-editor:not([trix-id])").forEach((el) => {
    el.replaceWith(el.cloneNode(true));
  });
});
